var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-small-class" },
    [
      _c("h1", { staticClass: "h1 color-gray-1" }, [
        _vm._v("Capstone Prerequisites")
      ]),
      _c("PrerequisitesContent", { attrs: { isPaid: _vm.isPaid } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }